import { createContext, ReactNode, useContext, useMemo } from 'react'
import { NextpeakClient } from './nextpeak.client.ts'
import { getActiveTokens } from '../../auth/utils.ts'
import { NEXTPEAK_API_URL } from '../../config.ts'
import { HttpClientFactory } from '../httpClient'
import { useAuth } from '../../AuthProvider.ts'

const NextPeakClientContext = createContext<NextpeakClient | null>(null)

export interface NextPeakClientProviderProps {
	children: ReactNode
}

export const NextPeakClientProvider = ({ children }: NextPeakClientProviderProps) => {
	const { organizationId, organizationToken, organizationTokenExpiresAt } = getActiveTokens()
	const { refreshAuth } = useAuth()

	const client = useMemo(() => {
		return new NextpeakClient(
			{
				baseUrl: NEXTPEAK_API_URL,
				getNewTokens: refreshAuth,
				orgId: organizationId ?? '',
			},
			new HttpClientFactory()
		)
	}, [organizationToken, organizationTokenExpiresAt, organizationId, refreshAuth])

	return <NextPeakClientContext.Provider value={client}>{children}</NextPeakClientContext.Provider>
}

export const useNextPeakClient = () => {
	const client = useContext(NextPeakClientContext)
	if (!client) throw new Error('nextPeakClient not found in context')
	return client
}
